<template>
<svg version="1.1" id="Livello_1" xmlns:x="&ns_extend;" xmlns:i="&ns_ai;" xmlns:graph="&ns_graphs;"
	 xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="319.839px"
	 height="40.079px" viewBox="479.759 59.558 319.839 40.079" enable-background="new 479.759 59.558 319.839 40.079"
	 xml:space="preserve">
<metadata>
	<sfw  xmlns="&ns_sfw;">
		<slices></slices>
		<sliceSourceBounds  height="40.079" width="319.839" y="521.02" x="799.581" bottomLeftOrigin="true"></sliceSourceBounds>
	</sfw>
</metadata>
<g>
	<polygon fill="#F29200" points="515.374,79.538 512.713,79.54 514.042,81.392 	"/>
	<polygon fill="#F29200" points="527.265,79.537 527.259,79.529 521.383,79.533 	"/>
	<polygon fill="#F29200" points="528.596,81.392 521.319,91.531 526.38,98.582 540.925,98.571 	"/>
</g>
<g>
	<polygon fill="#F29200" points="514.042,77.763 512.713,79.615 515.374,79.617 	"/>
	<polygon fill="#F29200" points="528.596,77.763 540.925,60.585 526.38,60.573 521.319,67.624 	"/>
	<polygon fill="#F29200" points="521.256,79.621 527.259,79.626 527.265,79.617 	"/>
</g>
<rect x="479.759" y="74.406" fill="#E6342A" width="38.583" height="9.416"/>
<polygon fill="#E6342A" points="526.925,79.615 512.38,79.626 498.713,60.584 513.259,60.573 "/>
<polygon fill="#E6342A" points="498.713,98.571 513.259,98.582 526.925,79.54 512.38,79.529 "/>
<g>
	<path fill="#11998E" d="M568.856,92.196l-0.938,6.387h-23.116c0.371-2.344,1.191-8.995,2.461-19.952
		c0.781-7.343,1.201-13.408,1.26-18.193h8.115c-0.333,1.915-1.094,7.979-2.286,18.193c-0.625,5.88-1.191,10.548-1.699,14.005
		C557.284,92.635,562.684,92.489,568.856,92.196z"/>
	<path fill="#11998E" d="M607.938,76.873c0,6.036-1.938,11.338-5.815,15.909s-8.755,6.855-14.634,6.855
		c-4.453,0-8.13-1.642-11.03-4.923c-2.9-3.281-4.35-7.411-4.35-12.392c0-6.094,1.953-11.412,5.859-15.953
		c3.906-4.541,8.779-6.812,14.619-6.812c4.454,0,8.125,1.636,11.016,4.907C606.492,67.738,607.938,71.873,607.938,76.873z
		 M600.174,77.429c0-3.496-0.854-6.289-2.563-8.379c-1.709-2.09-3.853-3.135-6.431-3.135c-3.398,0-6.123,1.641-8.173,4.922
		s-3.076,6.885-3.076,10.811c0,3.496,0.849,6.294,2.548,8.393c1.699,2.1,3.838,3.15,6.416,3.15c3.379,0,6.104-1.66,8.174-4.98
		S600.174,81.297,600.174,77.429z"/>
	<path fill="#11998E" d="M642.508,79.597c-0.215,1.387-0.605,4.415-1.172,9.083c-0.234,2.207-0.381,5.176-0.44,8.906
		c-4.707,1.191-8.545,1.787-11.513,1.787c-5.821,0-10.215-1.671-13.184-5.01c-2.969-3.34-4.453-7.423-4.453-12.246
		c0-6.329,2.168-11.612,6.504-15.85c4.336-4.238,9.707-6.357,16.113-6.357c2.988,0,5.595,0.283,7.823,0.85l-1.642,6.914
		c-2.813-0.8-5.38-1.201-7.705-1.201c-4.063,0-7.271,1.436-9.624,4.307c-2.354,2.871-3.53,6.406-3.53,10.606
		c0,3.379,0.932,6.234,2.798,8.568c1.865,2.334,4.536,3.501,8.013,3.501c1.055,0,2.304-0.117,3.75-0.351
		c-0.02-0.352-0.029-1.017-0.029-1.993c0-0.918,0.073-2.646,0.22-5.185c0.146-2.539,0.22-4.649,0.22-6.329L642.508,79.597
		L642.508,79.597z"/>
	<path fill="#11998E" d="M659.823,60.437c-0.352,2.188-1.113,8.252-2.285,18.193c-0.724,6.798-1.201,13.448-1.436,19.952h-8.203
		c0.43-2.755,1.27-9.404,2.52-19.952c0.742-7.128,1.143-13.193,1.201-18.193H659.823L659.823,60.437z"/>
	<path fill="#11998E" d="M690.643,60.788l-1.729,6.504c-2.383-0.957-5.029-1.436-7.939-1.436c-4.707,0-7.061,1.426-7.061,4.277
		c0,1.113,0.508,2.08,1.523,2.9c0.898,0.743,2.646,1.689,5.244,2.842c6.016,2.676,9.023,6.495,9.023,11.456
		c0,8.203-5.635,12.305-16.904,12.305c-3.535,0-6.787-0.45-9.756-1.349l2.08-6.533c2.871,1.094,5.645,1.642,8.32,1.642
		c2.539,0,4.414-0.195,5.625-0.586c2.148-0.684,3.223-2.013,3.223-3.985c0-1.288-0.586-2.441-1.758-3.456
		c-1.055-0.919-2.988-2.041-5.801-3.37c-5.391-2.559-8.086-6.113-8.086-10.664c0-4.062,1.396-6.997,4.189-8.804
		s6.377-2.71,10.752-2.71C685.223,59.822,688.241,60.144,690.643,60.788z"/>
	<path fill="#11998E" d="M724.54,60.437l-0.85,6.298c-3.691-0.293-7.168-0.439-10.43-0.439c-0.234,1.778-0.693,5.889-1.377,12.334
		c-0.801,7.559-1.299,14.209-1.494,19.952h-8.087c0.411-2.832,1.23-9.483,2.462-19.952c0.469-4.433,0.859-8.544,1.172-12.334
		c-2.617,0-6.23,0.157-10.84,0.469l0.908-6.328L724.54,60.437L724.54,60.437z"/>
	<path fill="#11998E" d="M738.045,60.437c-0.352,2.188-1.113,8.252-2.285,18.193c-0.723,6.798-1.201,13.448-1.436,19.952h-8.203
		c0.43-2.755,1.27-9.404,2.52-19.952c0.742-7.128,1.142-13.193,1.201-18.193H738.045L738.045,60.437z"/>
	<path fill="#11998E" d="M770.565,60.73l-1.67,6.768c-2.109-0.742-4.17-1.113-6.182-1.113c-3.926,0-7.008,1.445-9.244,4.336
		s-3.354,6.338-3.354,10.342c0,3.32,0.942,6.123,2.827,8.408s4.624,3.428,8.218,3.428c2.306,0,4.873-0.42,7.705-1.26l-1.201,6.738
		c-3.105,0.663-5.743,0.996-7.911,0.996c-5.898,0-10.316-1.704-13.256-5.113c-2.939-3.408-4.41-7.505-4.41-12.289
		c0-6.211,2.11-11.441,6.329-15.689s9.481-6.372,15.791-6.372C766.472,59.91,768.592,60.183,770.565,60.73z"/>
	<path fill="#11998E" d="M799.598,60.788l-1.729,6.504c-2.383-0.957-5.029-1.436-7.94-1.436c-4.707,0-7.06,1.426-7.06,4.277
		c0,1.113,0.507,2.08,1.523,2.9c0.898,0.743,2.646,1.689,5.244,2.842c6.016,2.676,9.023,6.495,9.023,11.456
		c0,8.203-5.635,12.305-16.904,12.305c-3.535,0-6.787-0.45-9.756-1.349l2.08-6.533c2.871,1.094,5.645,1.642,8.32,1.642
		c2.539,0,4.414-0.195,5.625-0.586c2.148-0.684,3.223-2.013,3.223-3.985c0-1.288-0.586-2.441-1.758-3.456
		c-1.055-0.919-2.988-2.041-5.801-3.37c-5.391-2.559-8.086-6.113-8.086-10.664c0-4.062,1.396-6.997,4.189-8.804
		s6.377-2.71,10.752-2.71C794.178,59.822,797.196,60.144,799.598,60.788z"/>
</g>
</svg>
</template>
<script>
import colors from "vuetify/es5/util/colors";
export default {
  name: "Logo",
  props: {
    size: {
      type: [String, Number],
      default: "50",
    },
    semiDark: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    baseColor() {
      return this.$vuetify.theme.dark
        ? colors.grey.lighten5
        : this.semiDark
        ? colors.grey.lighten5
        : colors.grey.darken4;
    },
    primary() {
      //return this.$vuetify.theme.themes.light.primary.base;
      return colors.mygreen.lighten1
    },
  },
};
</script>
